import React, { useState, useContext, useEffect } from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Checkbox as MuiCheckbox } from "@mui/material";
import FuncionesContext, {
  getAtributo,
} from "../../../context/FuncionesContext";
import PantallaContext from "../../../context/PantallaContext";
import ListadoContext from "../../context/ListadoContext";
import { useListadoStateStore } from "../../context/ListadoStateContext";

const Checkbox = ({ data, cab, campokey, indiceData, id_elemento }) => {
  const { superSubmit } = useContext(FuncionesContext);
  const { configuraciones_ref } = useContext(PantallaContext);
  const { ListadoDispatch } = useContext(ListadoContext);
  const setDatoEspecificoStore = useListadoStateStore(
    (state) => state.setDatoEspecifico
  );
  const rowDataFromStore = useListadoStateStore(
    (state) => state.datos[indiceData] ?? data
  );

  const [value, setValue] = useState(data[campokey]);
  const [lastValue, setLastValue] = useState(data[campokey]);
  const [update_id, setUpdateId] = useState(data[cab.update_id_alias]);

  const usarValores = cab.usar_valores?.split(",") ?? [];
  const checkedValue = usarValores[0]?.toString().trim() ?? "s";
  const uncheckedValue = usarValores[1]?.toString().trim() ?? "n";
  const usaSuperSubmit = !!cab.update_campo;

  const nombre = cab.nombre_alias ? data[cab.nombre_alias] : cab.nombre;
  const key = cab.campo_alias ? cab.campo_alias : cab.id_a;
  const currentData = usaSuperSubmit ? data : rowDataFromStore;
  const disabled = getAtributo("disabled", currentData, cab) === "s";
  const isCheckedValue = (currentValue) => {
    if (currentValue === null || currentValue === undefined) return false;
    return currentValue?.toString().trim() === checkedValue;
  };

  const actualizarValorLocal = (valor) => {
    if (usaSuperSubmit) {
      ListadoDispatch({
        type: "SET_DATO_ESPECIFICO",
        payload: {
          value: valor,
          indiceData,
          key,
        },
      });
    }

    setDatoEspecificoStore({
      value: valor,
      indiceData,
      key,
    });
  };

  const handleCancelar = () => {
    setValue(data[campokey]);
    setLastValue(data[campokey]);
  };

  const handleChange = async (e) => {
    const valor = e.target.checked ? checkedValue : uncheckedValue;
    const valorActual = usaSuperSubmit ? value : currentData?.[campokey];

    if (
      valor === null ||
      valorActual?.toString()?.trim() === valor.toString().trim()
    ) {
      return;
    }

    if (usaSuperSubmit) {
      setValue(valor);
    }

    if (!usaSuperSubmit) {
      setLastValue(valor);
      actualizarValorLocal(valor);
      return;
    }

    const { id_a } = cab;

    superSubmit({ valor, id_a, update_id, handleCancelar, cab, data })
      .then((result) => {
        setLastValue(valor);
        actualizarValorLocal(valor);

        if (result.data.eliminado) {
          ListadoDispatch({
            type: "SET_DATO_ESPECIFICO",
            payload: {
              value: null,
              indiceData,
              key: cab.update_id_alias,
            },
          });
          setDatoEspecificoStore({
            value: null,
            indiceData,
            key: cab.update_id_alias,
          });
          setUpdateId(null);
          return result;
        }

        ListadoDispatch({
          type: "SET_DATO_ESPECIFICO",
          payload: {
            value: result.data.registro.id,
            indiceData,
            key: cab.update_id_alias,
          },
        });
        setDatoEspecificoStore({
          value: result.data.registro.id,
          indiceData,
          key: cab.update_id_alias,
        });
        setUpdateId(result.data.registro.id);
        return result;
      })
      .catch(() => {
        handleCancelar();
      });
  };

  useEffect(() => {
    if (!usaSuperSubmit) return;
    if (configuraciones_ref[cab.id_a] === 1) return;

    setValue(data[campokey]);
    setLastValue(data[campokey]);
    setUpdateId(data[cab.update_id_alias]);
  }, [
    cab.id_a,
    cab.update_id_alias,
    campokey,
    configuraciones_ref,
    data[campokey],
    data[cab.update_id_alias],
    usaSuperSubmit,
  ]);

  return (
    <div
      id={id_elemento}
      className="cfsf_checkbox"
      style={{ marginLeft: "14px", display: "flex" }}
    >
      <FormControlLabel
        control={
          <MuiCheckbox
            checked={isCheckedValue(usaSuperSubmit ? value : currentData?.[campokey])}
            onChange={handleChange}
            disabled={disabled}
          />
        }
        label={cab.label}
        className={cab.className}
      />
      {/* {nombre && !cab.label ? (
        <div className="vista_label_checkbox">{nombre}</div>
      ) : null} */}
    </div>
  );
};

export default Checkbox;
